<template>
  <div class="min-h-screen grid grid-cols-1 lg:grid-cols-2 overflow-hidden">
    <div class="right hidden h-full bg-yankFire lg:flex flex-col">
      <div class="flex-shrink-0 py-12 px-16">
        <inertia-link :href="$route('home')" class="flex items-center">
          <LogoIcon class="h-7 text-aquamarine" />
          <span class="text-white font-semibold text-2xl">Media</span>
        </inertia-link>
      </div>

      <div class="flex-1 mt-6 flex flex-col items-center justify-center">
        <h1 class="text-white flex flex-col text-4xl 2xl:text-5xl font-bold space-y-2 2xl:space-y-4">
          <template v-if="$page.url == '/auth/register'">
            <span>Get Free Access to</span>
            <span>1,000s of Graphics!</span>
          </template>

          <template v-else-if="$page.url == '/auth/login'">
            <span>Welcome Back to Your</span>
            <span>Free Graphic Resource!</span>
          </template>
        </h1>

        <div class="max-w-lg w-full mx-auto xl:mt-16 2xl:mt-24">
          <img src="/assets/register-artwork.png" alt="Tithely Media" class="object-fit w-full">
        </div>
      </div>
    </div>
    <div class="left bg-white max-h-screen overflow-y-scroll flex flex-col">
      <MobileMenu class="lg:hidden" :user="$page.props.user"/>
      <div class=" px-6 lg:px-0 flex-1">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
  import LogoIcon from '@/components/svg/LogoIcon'
  import MobileMenu from '@/components/shared/app-menu/MobileMenu'

  export default {
    name: 'AuthLayout',

    components: {
      LogoIcon,
      MobileMenu,
    }
  }
</script>
